"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Sidebar = require("./Sidebar.styled");
var Sidebar = exports.Sidebar = function Sidebar(_ref) {
  var ContentComponent = _ref.contentComponent,
    sidebarTestId = _ref.sidebarTestId,
    children = _ref.children,
    minHeight = _ref.minHeight,
    maxWidth = _ref.maxWidth,
    isChat = _ref.isChat;
  return /*#__PURE__*/_react["default"].createElement(_Sidebar.SidebarWrapper, {
    "data-testid": sidebarTestId,
    $minHeight: minHeight,
    $maxWidth: maxWidth,
    $isChat: isChat
  }, /*#__PURE__*/_react["default"].createElement(_Sidebar.SidebarContentWrapper, {
    $isChat: isChat
  }, ContentComponent), children);
};
Sidebar.defaultProps = {
  sidebarTestId: 'sidebar-wrapper',
  minHeight: '100vh',
  maxWidth: '417px',
  isChat: false
};
Sidebar.propTypes = {
  contentComponent: _propTypes.node.isRequired,
  sidebarTestId: _propTypes.string,
  children: _propTypes.node.isRequired,
  minHeight: _propTypes.string,
  maxWidth: _propTypes.string,
  isChat: _propTypes.bool
};